module.exports = __webpack_public_path__ + "static/media/awards-page-title-bg.35e45912.png";